import { render } from "./RoleEdit.vue?vue&type=template&id=60803aed&scoped=true"
import script from "./RoleEdit.vue?vue&type=script&lang=js"
export * from "./RoleEdit.vue?vue&type=script&lang=js"

import "./RoleEdit.vue?vue&type=style&index=0&id=60803aed&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60803aed"]])

export default __exports__